module.exports = __webpack_public_path__ + "img/report_title_advice_d@2x.42ceabdb.png";